import React from 'react';
import { Box } from '@mui/material';
import { MicOff } from '@mui/icons-material';

/**
 * Mic Off Indicator Component
 * Shows a red circle with mic off icon
 */
function MicOffIndicator({ size = 'medium', position = 'absolute' }) {
  const sizes = {
    small: { width: 20, height: 20, iconSize: 12 },
    medium: { width: 24, height: 24, iconSize: 14 },
    large: { width: 32, height: 32, iconSize: 18 },
  };

  const sizeConfig = sizes[size] || sizes.medium;

  const positionStyles = position === 'absolute' ? {
    position: 'absolute',
    bottom: 8,
    right: 8,
  } : {};

  return (
    <Box
      sx={{
        ...positionStyles,
        backgroundColor: 'error.main',
        borderRadius: '50%',
        width: sizeConfig.width,
        height: sizeConfig.height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 60,
        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
      }}
    >
      <MicOff sx={{ fontSize: sizeConfig.iconSize, color: 'white' }} />
    </Box>
  );
}

export default MicOffIndicator;
